/**
 * Header key for the agent thread id. Defined here (the non-Redux request
 * boundary home) so query network code never imports it from the legacy
 * Redux selector module, which re-exports it for its remaining consumers.
 */
export const ExtendThreadIDHeader = 'X-Extend-Thread-ID'

export enum RequestConfig {
  Vault,
  Unauthed,
  Form,
  Default,
  Agent,
  /**
   * Unauthed JSON config targeting the Addressulator service host (country
   * reference data) instead of API_HOST.
   */
  Addressulator,
  /**
   * CSP-authenticated JSON config (CSP JWT, not the regular user JWT) for
   * customer-support-portal endpoints like /csp/me.
   */
  Csp,
}
